var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-top-wrapper"},[_c('div',{staticClass:"wrapImgTop"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.production ? 
        _vm.path_prefix.slice(0, -1).concat(require('../assets/images/goTop.svg')):
        require('../assets/images/goTop.svg'),"alt":"go to top"},on:{"click":_vm.scrollToTop}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }